import { getRequest, postRequest } from './config/public-request';
const SERVICE_URL = '/user';
export const getUser = () => getRequest(`${SERVICE_URL}`);
export const logout = () => postRequest(`${SERVICE_URL}/logout`);
export const login = (credentials: any) =>
  postRequest(`${SERVICE_URL}`, { ...credentials });
